export const DEFAULT_USER_PHOTO = "https://torresowo.myftp.org/cap17drive/v2/files/b0a028ccbcededcd8d6ff17819582499";
export const DISCORD_CLIENT_ID = "1345581737052475495"; // Coloca aquí tu Client ID de la aplicación de Discord